<template>
  <el-drawer
    title="進場紀錄詳情"
    :visible.sync="syncShow"
    :append-to-body="true"
    destroy-on-close
    size="600px"
    class="classTicket-record-detail"
    @close="$emit('close')"
  >
    <div style="padding: 20px">
      <EntryInfoBlock :data="selectEntryRecord" @manualExit="manualExit()" />
    </div>
  </el-drawer>
</template>

<script>
import { defineComponent } from 'vue'
import EntryInfoBlock from './EntryInfoBlock.vue'

export default defineComponent({
  name: 'EntryRecordDetail',
  components: {
    EntryInfoBlock,
  },
  props: {
    show: Boolean,
    selectEntryRecord: Object,
  },
  setup (props, { emit }) {
    const manualExit = () => { emit('manualExit') }
    return { manualExit }
  },
  computed: {
    syncShow: {
      get () {
        return this.show
      },
      set (data) {
        this.$emit('opend:show', data)
      },
    },
  },
})
</script>

<style lang="postcss" scoped>
::v-deep .el-form-item {
@apply mb-0;
}

.section-block-title {
@apply text-primary-100 font-medium text-[18px] pb-[12px];
}
::v-deep .el-drawer__header {
@apply mb-0;
}

</style>
